<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre4" id="untitled-1"></div>
<div class="calibre1">
<div class="calibre1">
<p class="normal"><span class="no-style-override10"><br class="calibre5"/></span></p>
</div>
<div class="calibre1">
<p class="part" id="toc-anchor">PART I</p>
<p class="part-title" id="toc-anchor-3"><br class="calibre1"/></p>
<p class="part-title" id="toc-anchor-4"><br class="calibre1"/></p>
<p class="part-title" id="toc-anchor-5">Every Parent’s Nightmare</p>
<p class="calibre3" id="calibre_pb_18"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PartOne.vue?3586693e